import React, { useState } from "react";
import { notAssessableAndAssessableOptions } from "../../../Options/commonOptions";
import { speechTypeOptions } from "../../../Options/functionalAsessmentOptions";
import DeselectableRadioGroup from "../../../../../blocks/FormItems/DeselectableRadioGroup";
import { hexToRgba } from "../../../../../helpers/utility";
import {theme} from "antd";
const Speech = ({ form }) => {
  const [refresh, setRefresh] = useState(false);
  const { token } = theme.useToken();
  return (
    <>
      <DeselectableRadioGroup
        label={"Speech"}
        name={["speech_details", "speech"]}
        options={notAssessableAndAssessableOptions}
        form={form}
        setRefresh={setRefresh}
      />
      {form.getFieldValue(["speech_details", "speech"]) === "assessable" && (
        <div
                      className="subsection-card"
                      style={{
                        borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
                        background: "transparent",
                        marginTop: "8px",
                        padding: "8px 12px",
                        borderRadius: "8px",
                      }}
                    >
          <DeselectableRadioGroup
            name={["speech_details", "speech_type"]}
            options={speechTypeOptions}
            form={form}
          />
        </div>
      )}
    </>
  );
};

export default Speech;
